import { Button, Card, Space } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ResponsiveContainer from '../components/ResponsiveContainer';
import UserContext from '../context/user-context';

function Organizacion() {
  const { user } = useContext(UserContext);

  const [tieneGestionUsuarios, setTieneGestionUsuarios] = useState();
  const [tieneGestionSistema, setTieneGestionSistema] = useState();
  const history = useHistory();

  const sucursales = async () => {
    history.push(`/sucursales`);
  };

  const usuarios = async () => {
    history.push(`/usuarios`);
  };

  useEffect(() => {
    if (user) {
      if (user.usuarioSegu.gestion_usuarios) {
        setTieneGestionUsuarios(true);
      } else {
        setTieneGestionUsuarios(false);
      }
      if (user.usuarioSegu.gestion_sistema) {
        setTieneGestionSistema(true);
      } else {
        setTieneGestionSistema(false);
      }
    }
  }, [user]);

  return (
    <ResponsiveContainer size="large">
      <Card title="Organización" style={{ textAlign: 'left' }}>
        <Space direction="vertical">
          {tieneGestionSistema && (
            <Button type="link" onClick={sucursales}>
              Sucursales
            </Button>
          )}
          {tieneGestionUsuarios && (
            <Button type="link" onClick={usuarios}>
              Usuarios
            </Button>
          )}
        </Space>
      </Card>
    </ResponsiveContainer>
  );
}

export default Organizacion;
